import { EventEmitter, Inject, Injectable } from "@angular/core";

import { AppServiceBase } from "@definitiv-packages/angular-dba-library";
import { AngularPermissionLibraryService } from "@definitiv-packages/angular-permissions-library";
import { AngularGroupsLibraryService } from "@definitiv-packages/angular-group-library";
import { AngularModuleLibraryService } from "@definitiv-packages/angular-module-library";
import { DBAPushService } from "@definitiv-packages/angular-push-library";

import { ProjektPermissionService } from "./projektpermission.service";
import { ProjectLanguage } from "../types/ProjectLanguage";
import { ProjectEnvironment } from "../../public-api";


@Injectable({
    providedIn: 'root'
})
export class AppService extends AppServiceBase<ProjectLanguage> {
    public logoutEvent: EventEmitter<void> = new EventEmitter();

    constructor(
        @Inject(ProjectEnvironment) private environment: ProjectEnvironment,
        private permisssionLibrary: AngularPermissionLibraryService,
        private groupLibrary: AngularGroupsLibraryService,
        private moduleLibrary: AngularModuleLibraryService,
        private permissionService: ProjektPermissionService,
        private pushService: DBAPushService
    ) { super(new ProjectLanguage()); }

    protected override async initApp(): Promise<void> {
        await Promise.all([
            this.permisssionLibrary.init(""),
            this.groupLibrary.init(""),
            this.moduleLibrary.init(""),
            this.initPush()
        ]);

        if (!this.environment.production) this.languageService.findMissingServerStrings(new ProjectLanguage());
    }

    protected override async actionAfterLogin(): Promise<void> {
        await this.permissionService.init();
    }

    public initPush(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            var pushLibraryPromise = this.pushService.init(
                this.environment.apiUri + "/PushEndpoint.php",
                this.environment.apiUri + "/PushEndpointNL.php",
                this.environment.vapidPublicKey);
            Promise.all([pushLibraryPromise]).then(() => {
                resolve();
            }).catch(error => {
                console.log("Push Konnte nicht Initialisiert werden");
                resolve();
            });
        });
    }
}
